const TOKEN_STORAGE_KEY = "ashtra_session_token";
let volatileToken: string | null = null;

function browserStorage(): Storage | null {
  if (typeof window === "undefined") return null;
  try {
    return window.localStorage;
  } catch {
    return null;
  }
}

/**
 * Single source of truth for persisting the session bearer token. Other
 * short-lived auth handoffs use separate storage modules and keys; no other
 * module may read or write this session-token key.
 * Wrapped in try/catch because storage can throw (private browsing, quota,
 * disabled storage) and a storage failure must never crash the app; it
 * just means the session won't survive a reload.
 */
export function getStoredToken(): string | null {
  try {
    return browserStorage()?.getItem(TOKEN_STORAGE_KEY) ?? volatileToken;
  } catch {
    return volatileToken;
  }
}

export function setStoredToken(token: string): void {
  volatileToken = token;
  try {
    browserStorage()?.setItem(TOKEN_STORAGE_KEY, token);
  } catch {
    // Non-fatal: retain this tab's session without persisting it across reloads.
  }
}

export function clearStoredToken(): void {
  volatileToken = null;
  try {
    browserStorage()?.removeItem(TOKEN_STORAGE_KEY);
  } catch {
    // Non-fatal: the in-memory value was already cleared.
  }
}
